module.exports = __webpack_public_path__ + "img/secondHand_header.dbae46be.png";